// extracted by mini-css-extract-plugin
export default {"socialLinks":"SocialLinks_socialLinks__F8LIT","separator":"SocialLinks_separator__-5rmg"};